import { useState, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import ModalContainer from '../../ModalContainer/ModelContainer'
import { CREATE_FROM } from '../helpers'

import BaseView from './components/BaseView'
import SelectInspectionTrigger from './components/SelectInspectionTrigger'
import SelectCreateInspectionFrom from './components/SelectCreateInspectionFrom'
import CreateInspectionFromTemplate from './components/CreateInspectionFromTemplate'
import SelectInspectionTemplate from './components/SelectInspectionTemplate'

const ScheduleInspectionModal = ({ onClose = () => {} }) => {
  const { t } = useTranslation(['internal-inspections'])
  const [currentTrigger, setCurrentTrigger] = useState(null)
  const [createFrom, setCreateFrom] = useState(null)
  const [selectedTemplate, setSelectedTemplate] = useState(null)
  const navigate = useNavigate()

  const onCreateFromBlank = () => {
    navigate(`/dashboard/building-dashboard/internal-inspections/${currentTrigger}/create`)
    onClose()
  }

  const views = useMemo(() => {
    const views = [
      {
        Component: SelectInspectionTrigger,
        config: { value: currentTrigger, onSelect: (name) => setCurrentTrigger(name) },
      },
      {
        Component: SelectCreateInspectionFrom,
        config: {
          value: createFrom,
          onSelect: (name) => setCreateFrom(name),
          ...(createFrom === CREATE_FROM.BLANK && { onNext: onCreateFromBlank }),
        },
      },
    ]

    if (createFrom === CREATE_FROM.TEMPLATE) {
      return [
        ...views,
        {
          Component: SelectInspectionTemplate,
          config: {
            value: selectedTemplate,
            onSelect: (template) => setSelectedTemplate(template),
          },
        },
        {
          Component: CreateInspectionFromTemplate,
          config: { currentTrigger, selectedTemplate, onClose },
        },
      ]
    }

    return views
  }, [createFrom, currentTrigger, selectedTemplate])

  return (
    <ModalContainer
      additionalClass="internal-inspections-modal"
      onClose={onClose}
      headerTitle={t('internal-inspections:navbar.scheduleInspection')}
    >
      <BaseView steps={views} onClose={onClose} />
    </ModalContainer>
  )
}

ScheduleInspectionModal.propTypes = {
  onClose: PropTypes.func,
}

export default ScheduleInspectionModal
